import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';
import { computed } from 'vue';

export const useArticleStatuses = defineStore('article-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.articleStatus_ListStatuses,
    dto: 'ArticleStatusDto',
    create: api.articleStatus_AddStatus,
    update: api.articleStatus_UpdateStatus,
    delete: api.articleStatus_DeleteStatus,
    usage: api.articleStatus_GetUsage,
    signalR: 'ArticleStatusUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.articleStatus_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  //TODO: Just based on heuristics, so not 100% reliable. Could be a bool in DB instead?
  const archivedStatus = computed(() => {
    return (
      globalStoreBase.loaded.value.find((x) => x.name.toLowerCase() === 'archived') ??
      globalStoreBase.loaded.value.find((x) => x.name.toLowerCase() === 'archive') ??
      globalStoreBase.loaded.value[globalStoreBase.loaded.value.length - 1] // Usually the last status is the archived one
    );
  });

  return {
    ...globalStoreBase,
    archivedStatus,
    replace,
  };
});
